import {
  FETCH_FAQ_CATEGORIES_REQUEST,
  FETCH_FAQ_CATEGORIES_SUCCESS,
  FETCH_FAQ_CATEGORIES_FAILURE
} from './actions';

export const initialState = {
  isFetching: false,
  isFetched: false,
  categoryIds: [],
  error: false
};

export default function faqReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_FAQ_CATEGORIES_REQUEST:
      return {
        ...state,
        isFetching: true,
        isFetched: false
      };
    case FETCH_FAQ_CATEGORIES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        categoryIds: action.payload.result
      };
    case FETCH_FAQ_CATEGORIES_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        error: true
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/faq/reducer.js